export const HISTORY_TYPES = [
    { id: 1, name: 'Создание', value: 1 },
    { id: 2, name: 'Редактирование', value: 2 },
    { id: 3, name: 'Удаление', value: 3 },
]
